import {combineReducers} from "redux"
import assumptions from "./assumptions"
import calculation from "./calculation"
import edit from "./edit"
import jurisdictions from "./jurisdictions"
import report from "./report"

// SELECTORS
export const getCostProjection = (state) => state.costProjection

// REDUCER
export default combineReducers({
  assumptions,
  calculation,
  edit,
  jurisdictions,
  report,
})
